/* eslint-disable indent */
import utils from '../utils';

const useFormularioExcel = () => {
  const getFormDataForExcel = ({ foilData }) => {
    const isListaInvValid = Array.isArray(foilData?.listaInv);

    if (foilData) {
      return {
        principalData: [
          {
            col1: 'Folio:',
            col2: foilData?.folio || '-',
            col3: '',
            col4: '',
            col5: '',
            col6: '',
            // col7: 'Fecha de creación:',
            // col8: utils.getDateFormat(new Date(), 'dd/MM/YYY'),
          },
          {
            col1: 'Género',
            col2: foilData?.genero || ' - ',
            col3: '',
            col4: '',
            col5: '',
            col6: '',
          },
          {
            col1: 'Tipo de usuario',
            col2: foilData?.tipoUsuario || ' - ',
            col3: '',
            col4: '',
            col5: '',
            col6: '',
          },
          {
            col1: 'Tipo de denuncia',
            col2: foilData?.usrAnonimo ? 'Anónimo' : 'No anónimo',
            col3: '',
            col4: '',
            col5: '',
            col6: '',
          },
          ...(!foilData?.usrAnonimo
            ? [
              {
                col1: 'Nombre completo',
                col2: `${foilData?.usrNombre} ${foilData?.usrApellido}`,
                col3: '',
                col4: '',
                col5: '',
                col6: '',
              },
              {
                col1: 'Teléfono fijo o celular',
                col2: foilData?.usrTelefono || ' - ',
                col3: '',
                col4: '',
                col5: '',
                col6: '',
              },
              {
                col1: 'Correo electrónico',
                col2: foilData?.usrCorreo || ' - ',
                col3: '',
                col4: '',
                col5: '',
                col6: '',
              },
              {
                col1: 'Puesto',
                col2: foilData?.usrPuesto || ' - ',
                col3: '',
                col4: '',
                col5: '',
                col6: '',
              },
              {
                col1: 'Ubicación',
                col2: foilData?.usrUbicacion || ' - ',
                col3: '',
                col4: '',
                col5: '',
                col6: '',
              },
            ]
            : [
              {
                col1: 'Teléfono fijo o celular',
                col2: foilData?.usrTelefono || ' - ',
                col3: '',
                col4: '',
                col5: '',
                col6: '',
              },
              {
                col1: 'Correo electrónico',
                col2: foilData?.usrCorreo || ' - ',
                col3: '',
                col4: '',
                col5: '',
                col6: '',
              },
            ]),
          ...(foilData?.tipoDenunciaMejora?.length
            ? [
              {
                col1: 'Comportamiento o mejora',
                col2: foilData?.tipoDenunciaMejora || ' - ',
                col3: '',
                col4: '',
                col5: '',
                col6: '',
              },
            ]
            : []),
          ...(foilData?.tipoConducta?.length
            ? [
              {
                col1: 'Tipo de conducta',
                col2: foilData?.tipoConducta || ' - ',
                col3: '',
                col4: '',
                col5: '',
                col6: '',
              },
            ]
            : []),
          {
            col1: 'Fecha del incidente',
            col2: foilData?.fechaEvento || '-',
            col3: '',
            col4: '',
            col5: '',
            col6: '',
          },
          {
            col1: 'Ubicación y el área que deseas reportar o sugerir para mejorar',
            col2: foilData?.ubicacion || ' - ',
            col3: '',
            col4: '',
            col5: '',
            col6: '',
          },
          ...(foilData?.area?.length
            ? [
              {
                col1: 'Area de la ubicación',
                col2: foilData?.area || ' - ',
                col3: '',
                col4: '',
                col5: '',
                col6: '',
              },
            ]
            : []),
          ...(foilData?.departamento?.length
            ? [
              {
                col1: 'Tipo de departamento',
                col2: foilData?.departamento || ' - ',
                col3: '',
                col4: '',
                col5: '',
                col6: '',
              },
            ]
            : []),
          {
            col1: 'Comentarios',
            col2: foilData?.txtSituacion || ' - ',
            col3: '',
            col4: '',
            col5: '',
            col6: '',
          },
        ],
        infractorData: [
          ...(isListaInvValid && foilData?.listaInv?.filter(el => el.tipoInvolucrado === 'Infractor')?.length
            ? foilData?.listaInv
              .filter(el => el.tipoInvolucrado === 'Infractor')
              .map(el => ({
                invNombre: `${el?.invNombre || '-'} ${el?.invApellido || ''}`,
                invPuestoRelacion: el?.invPuestoRelacion || ' - ',
                invAreaTrabajo: el?.invAreaTrabajo || ' - ',
              }))
            : []),
        ],
        testigoData: [
          ...(isListaInvValid && foilData?.listaInv?.filter(el => el.tipoInvolucrado === 'Testigo')?.length
            ? foilData?.listaInv
              .filter(el => el.tipoInvolucrado === 'Testigo')
              .map(el => ({
                invNombre: `${el?.invNombre || '-'} ${el?.invApellido || ''}`,
                invPuestoRelacion: el?.invPuestoRelacion || ' - ',
                invUbicacion: el?.invUbicacion || ' - ',
                invTelMovil: el?.invTelMovil || ' - ',
                invAreaTrabajo: el?.invAreaTrabajo || ' - ',
              }))
            : []),
        ],
        afectadoData: [
          ...(isListaInvValid &&
          foilData.afectadoDirecto === 'no' &&
          foilData?.listaInv?.filter(el => el.tipoInvolucrado === 'Afectado')?.length
            ? foilData?.listaInv
              .filter(el => el.tipoInvolucrado === 'Afectado')
              .map(el => ({
                invNombre: `${el?.invNombre || '-'} ${el?.invApellido || ''}`,
                invPuestoRelacion: el?.invPuestoRelacion || ' - ',
                invUbicacion: el?.invUbicacion || ' - ',
                invTelMovil: el?.invTelMovil || ' - ',
              }))
            : []),
        ],
      };
    }
    return {
      principalData: [],
      infractorData: [],
      testigoData: [],
      afectadoData: [],
    };
  };

  return {
    getFormDataForExcel,
  };
};

export default useFormularioExcel;
